import axios from "axios";
import { defHttp } from "../utils/http/axios";

const Api = {
    /**
     * Chat Endpoints
     */
    sendUserMessage: "/cat/gptChat/conversation/user/send",
    replyUserMessage: "/cat/gptChat/conversation/assistant/reply",
    getConversationList: "/cat/gptChat/conversation/list",
    deleteChatHistory: "/cat/gptChat/conversations/delete",

    /**
     * Configuration
     */
    getChatConfig: "/cat/gptChat/config",
    saveUserSettings: "/cat/gptChat/config/save",
};

/**
 * 发送用户聊天内容
 * @param {Object} data Message data
 */
export function sendUserMessage(data) {
    return defHttp.post({ url: Api.sendUserMessage, data });
}

/**
 * 2 分钟超时，与 saipan 后台的聊天超时设置一致。
 * 增加 10 秒钟缓冲时间，以考虑网络延迟、后台处理、消息队列处理...
 * @type {number}
 */
const AI_ASSISTANT_TIME_OUT = 2 * 60 * 1000 + 10 * 1000;
/**
 * 获取AI助手的回复
 * 2 分钟超时，与 saipan 后台的聊天超时设置一致
 *
 * @param {Object} params Query parameters
 */
export function replyUserMessage(params) {
    return defHttp.get({ url: Api.replyUserMessage, params, timeout: AI_ASSISTANT_TIME_OUT });
}

/**
 * 查询聊天历史
 * @param {Object} params Query parameters
 * @returns {{cancel: (function(): void), promise: Promise<*>}}
 */
export function getGptConversations(params) {
    return defHttp.getWithCancel({
        url: Api.getConversationList,
        params,
    });
}

/**
 * 获取用户AI助手配置
 */
export function getChatConfig() {
    return defHttp.get({ url: Api.getChatConfig });
}

/**
 * 保存用户AI助手配置
 * @param {Object} data Settings data
 */
export function saveUserSettings(data) {
    return defHttp.post({ url: Api.saveUserSettings, data });
}

/**
 * 删除聊天历史
 * @param {Object} params Query parameters
 */
export function deleteChatHistory(params) {
    return defHttp.get({ url: Api.deleteChatHistory, params });
}
